// extracted by mini-css-extract-plugin
export var externalLink = "_c6-0";
export var internalLinkLabel = "_c6-1";